/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The groups a pricing experiment splits its audience into. Each organization is assigned to exactly one arm,
 * and the experiment is measured by comparing how the arms behave.
 */
export enum PricingExperimentArm {
    /**
     * The unchanged baseline the experiment is measured against, quoted the current public pricing
     */
	Control = 'Control',
    /**
     * The group the experiment is testing, quoted the experiment's pricing tier instead
     */
	Variant = 'Variant',
}
